export const ADD_ARRAY_VALUE = 'redux-form/ADD_ARRAY_VALUE';
export const AUTOFILL = 'redux-form/AUTOFILL';
export const BLUR = 'redux-form/BLUR';
export const CHANGE = 'redux-form/CHANGE';
export const DESTROY = 'redux-form/DESTROY';
export const FOCUS = 'redux-form/FOCUS';
export const INITIALIZE = 'redux-form/INITIALIZE';
export const REMOVE_ARRAY_VALUE = 'redux-form/REMOVE_ARRAY_VALUE';
export const RESET = 'redux-form/RESET';
export const START_ASYNC_VALIDATION = 'redux-form/START_ASYNC_VALIDATION';
export const START_SUBMIT = 'redux-form/START_SUBMIT';
export const STOP_ASYNC_VALIDATION = 'redux-form/STOP_ASYNC_VALIDATION';
export const STOP_SUBMIT = 'redux-form/STOP_SUBMIT';
export const SUBMIT_FAILED = 'redux-form/SUBMIT_FAILED';
export const SWAP_ARRAY_VALUES = 'redux-form/SWAP_ARRAY_VALUES';
export const TOUCH = 'redux-form/TOUCH';
export const UNTOUCH = 'redux-form/UNTOUCH';
